export default "__VITE_ASSET__5uuswHWD__"